import { render, staticRenderFns } from "./RsaPazienteRiunioneEquipeListComponent.vue?vue&type=template&id=d0a6691e"
import script from "./RsaPazienteRiunioneEquipeListComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazienteRiunioneEquipeListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports